module.exports = __webpack_public_path__ + "assets/578e8f02cb9e3fca742f00a20ba100ee.jpg";